export const CHAT_OPEN_SUCCESS = "CHAT_OPEN_SUCCESS"
export const CHAT_CLOSE_SUCCESS = "CHAT_CLOSE_SUCCESS"


export const GET_SINGLE_CHAT_REQUEST = 'GET_SINGLE_CHAT_REQUEST'
export const GET_SINGLE_CHAT_SUCCESS = 'GET_SINGLE_CHAT_SUCCESS'
export const GET_SINGLE_CHAT_FAIL = 'GET_SINGLE_CHAT_FAIL'


